import { useState } from 'react'
import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    transactionInProgressTitle: translate({
      id: 'global.editingInProgress',
    }),
  }))

  return api
}
